import {useState,useEffect} from 'react'
import EditArticle from "./editArticle"

import {supabase, supabaseUrl} from "./supabaseClient"

type ArticleProps = {
  id: string;
  title: string;
  content: string;
  title_img: string;
  post_date: string;
  update_date: string;
}

export default function Article({article}:any) {

  const [modal_open, set_modal_open] = useState(false);

  useEffect(() => {
    console.log(article.post_date)
    const post_date = new Date(article.post_date)
    console.log(post_date)
    console.log(post_date.toLocaleString())
  },[])

  const deleteArticle = async () => {
    const { error } = await supabase
      .from('article')
      .delete()
      .eq('id', article.id)

    console.log(error)
    window.location.reload()
  }


  const openModal = ()=>{
    set_modal_open(true);
  }
  const closeModal = () => {
    set_modal_open(false)
  }

  return (
    <div className="flex flex-col items-center overflow-hidden rounded-lg border md:flex-row">
      <a href="#" className="group relative block h-48 w-full shrink-0 self-start overflow-hidden bg-gray-100 md:h-full md:w-32 lg:w-48">
        <img src={`${supabaseUrl}/storage/v1/object/public/title_image/${article.title_img}?auto=format&q=75&fit=crop&w=600`} loading="lazy" alt="Photo by Minh Pham" className="absolute inset-0 h-full w-full object-cover object-center transition duration-200 group-hover:scale-110" />
      </a>

      <div className="flex flex-col gap-2 p-4 lg:p-6">
        <span className="text-sm text-gray-400">投稿日:{new Date(article.post_date).toLocaleString()}</span>

        <h2 className="text-xl font-bold text-gray-800">
          <a href="#" className="transition duration-100 hover:text-indigo-500 active:text-indigo-600">{article.title}</a>
        </h2>


        <div>
          {/*<a href="#" className="font-semibold text-indigo-500 transition duration-100 hover:text-indigo-600 active:text-indigo-700">Read more</a>*/}
          <button type="button" onClick={openModal} className="px-8 py-3 mx-4 font-semibold rounded-full dark:bg-green-100 dark:text-green-800">編集</button>
          <button type="button" onClick={deleteArticle} className="px-8 py-3 font-semibold rounded-full dark:bg-red-100 dark:text-red-800">削除</button>
        </div>
      </div>

      <EditArticle
        modal_open={modal_open}
        closeModal={closeModal}
        article={article}
      ></EditArticle>
    </div>
  )
}